module.exports = __webpack_public_path__ + "static/avCircleLogo-9393f3b282a0998467f1dcac933885ec.svg";